type Translate = (key: string, options?: Record<string, unknown>) => string;

/** 登録数量の既定単位（DB が空のときの表示・新規登録） */
export const SAMPLE_DEFAULT_UNIT = 'vials';

/** フォーム select 用（value は DB 保存値） */
export const SAMPLE_UNIT_OPTIONS = [
  { value: 'vials', labelKey: 'sample.unit_vial' },
  { value: 'tubes', labelKey: 'sample.unit_tube' },
  { value: 'ml', labelKey: 'sample.unit_ml' },
  { value: 'ul', labelKey: 'sample.unit_ul' },
] as const;

/** DB に残る英語単位 → i18n キー（未知の値はそのまま表示） */
const UNIT_LABEL_KEYS: Record<string, string> = {
  vial: 'sample.unit_vial',
  vials: 'sample.unit_vial',
  tube: 'sample.unit_tube',
  tubes: 'sample.unit_tube',
  ml: 'sample.unit_ml',
  µl: 'sample.unit_ul',
  ul: 'sample.unit_ul',
  μl: 'sample.unit_ul',
};

/**
 * サンプル数量の単位表示。
 * 空のときは既定 `vials`（日本語 UI では「本」）を使う。
 */
export function formatSampleUnitDisplay(
  unit: string | null | undefined,
  t: Translate,
  /** 渡すと EN 等で vial/vials を切り替える（未指定は複数形ラベル） */
  count?: number
): string {
  const raw = unit?.trim() || SAMPLE_DEFAULT_UNIT;
  const key = UNIT_LABEL_KEYS[raw.toLowerCase()];
  if (!key) return raw;
  if (typeof count === 'number' && Number.isFinite(count)) {
    return t(key, { count, defaultValue: raw });
  }
  return t(key, { defaultValue: raw });
}

/** `4 本` / `4 vials` のように数量＋単位 */
export function formatSampleQuantityWithUnit(
  quantity: number | string | null | undefined,
  unit: string | null | undefined,
  t: Translate
): string {
  if (quantity == null || quantity === '') return '-';
  const numeric =
    typeof quantity === 'number'
      ? quantity
      : Number(String(quantity).replace(/,/g, '').trim());
  const u = formatSampleUnitDisplay(
    unit,
    t,
    Number.isFinite(numeric) ? numeric : undefined
  );
  return u ? `${quantity} ${u}` : String(quantity);
}
